import { useEffect } from "react";

export default function useCourseMeta(title: string, description: string, path: string) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    const entries = [
      { selector: 'meta[name="description"]', tag: "meta", key: "content", value: description, identity: ["name", "description"] },
      { selector: 'link[rel="canonical"]', tag: "link", key: "href", value: `https://wmt-ai.ru${path}`, identity: ["rel", "canonical"] },
      { selector: 'meta[property="og:title"]', tag: "meta", key: "content", value: title, identity: ["property", "og:title"] },
      { selector: 'meta[property="og:description"]', tag: "meta", key: "content", value: description, identity: ["property", "og:description"] },
      { selector: 'meta[property="og:url"]', tag: "meta", key: "content", value: `https://wmt-ai.ru${path}`, identity: ["property", "og:url"] },
    ];
    const cleanups = entries.map(entry => {
      const existing = document.head.querySelector(entry.selector);
      const element = existing || document.createElement(entry.tag);
      const previous = element.getAttribute(entry.key);
      element.setAttribute(entry.identity[0], entry.identity[1]);
      element.setAttribute(entry.key, entry.value);
      if (!existing) document.head.appendChild(element);
      return () => { if (!existing) element.remove(); else if (previous === null) element.removeAttribute(entry.key); else element.setAttribute(entry.key, previous); };
    });
    return () => { document.title = previousTitle; cleanups.forEach(cleanup => cleanup()); };
  }, [title, description, path]);
}
